import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

import { ProjectTour } from '../entities/project-tour.entity';

type Params = {
  project: ProjectTour;
};

export const editProjectTour = createAppAsyncThunk(
  'projectTour/editProjectTour',
  async (
    params: Params,
    { extra: { projectTourGateway, snackbarGateway } },
  ): Promise<void> => {
    try {
      await projectTourGateway.edit(params.project);
      showSnackbarSuccess(snackbarGateway);
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('EditProject.Message.error'));
}

function showSnackbarSuccess(snackbarGateway: SnackbarGateway) {
  snackbarGateway.success(translate('EditProject.Message.success'));
}
